import Vue from 'vue'
import Router from 'vue-router'  // 引入vue-router
// 使用插件
Vue.use(Router)

// 引入路由组件
import index from '@/pages/index'
import login from '@/pages/login'
import query from '@/pages/query'

// 配置路由路径
export default new Router({
  mode: 'hash',
  routes:[

      {
        path: '/',
        name: 'login',
        component: login,
      },

      { path: '/index', 
        name:'index',
        component: index
      },

      {  path: '/query', 
        name:'query',
        component: query
    },
  ]
});



  // const router = new VueRouter({
  //   'mode':'history',
  //   routes // (缩写) 相当于 routes: routes
  // })
  
// export default router;